import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AlertOctagon, ShieldAlert } from 'lucide-react';
import { UnifiedErrorsLog } from './UnifiedErrorsLog';
import { RateLimitMonitor } from './RateLimitMonitor';

export function ErrorsManager() {
  return (
    <Tabs defaultValue="all-errors" className="space-y-6">
      <div className="rounded-xl border border-border/60 bg-card p-1.5">
        <TabsList className="grid w-full grid-cols-2 h-auto bg-transparent gap-1 p-0">
          <TabsTrigger value="all-errors" className="gap-2">
            <AlertOctagon className="h-4 w-4" />
            <span className="hidden sm:inline">All Errors</span>
            <span className="sm:hidden">Errors</span>
          </TabsTrigger>
          <TabsTrigger value="rate-limits" className="gap-2">
            <ShieldAlert className="h-4 w-4" />
            <span className="hidden sm:inline">Rate Limits</span>
            <span className="sm:hidden">Limits</span>
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="all-errors" className="mt-0"><UnifiedErrorsLog /></TabsContent>
      <TabsContent value="rate-limits" className="mt-0"><RateLimitMonitor /></TabsContent>
    </Tabs>
  );
}
